import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface CustomerInformationReduxSliceState {
    id?: number;
    name?: string;
    code?: string;
}


type SetCustomerInformationPayload = Partial<CustomerInformationReduxSliceState>;


const initialState: CustomerInformationReduxSliceState = {}

const sliceName = 'customerInformation';

/**
 * The Redux state, action creators, types and reducers of the customer-information slice.
 */
export const CustomerInformationReduxSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        setCustomerInformation: (
            state,
            action: PayloadAction<SetCustomerInformationPayload>) => {
            Object
                .keys(action.payload)
                .forEach((key) => {
                    state[key as keyof SetCustomerInformationPayload] = action.payload[key as keyof SetCustomerInformationPayload] as any;
                });
            return state;
        },
        clearCustomerInformation: () => initialState,
    }
});

export default CustomerInformationReduxSlice;
